import { FC } from "react";
import { LicenseInfo } from "@mui/x-license-pro";
import { ThemeProvider } from "@mui/material/styles";

import "./App.css";
import { RootState } from "./app/store";
import { theme } from "./shared/theme";
import { useAppSelector } from "./app/hooks";
import AppRouter from "./app/router";
import Loader from "./features/components/loader";
import ValidationDialog from "./features/components/validation-dialog";
import ErrorDialog from "./features/components/error-dialog";
import WarningAcknowledgmentDialog from "./features/components/warning-acknowledgment-dialog";

LicenseInfo.setLicenseKey(
  "b6a437f788087c4db3526ad23cc34737Tz0xMTQ4NTAsRT0xNzgxOTEzNTk5MDAwLFM9cHJvLExNPXN1YnNjcmlwdGlvbixQVj1RMy0yMDI0LEtWPTI="
);

const App: FC = () => {
  const appLoading = useAppSelector((state: RootState) => state.app.loading);
  const matterLoading = useAppSelector(
    (state: RootState) => state.matter.loading
  );

  return (
    <ThemeProvider theme={theme}>
      {(appLoading || matterLoading) && <Loader overlay />}
      <AppRouter />
      <ValidationDialog />
      <ErrorDialog />
      <WarningAcknowledgmentDialog />
    </ThemeProvider>
  );
};

export default App;
